var sections = {
  md: [

  ],
  sv: [
    {
      name: "Speakers",
      type: 'speaker',
      icon: "FiMic",
      app: true,
      web: true,
    },
    {
      name: "Gallery",
      icon: "MdInsertPhoto",
      type: "gallery",
      app: true,
      web: true,
    },
    {
      icon: "MdChat",
      name: "Activity Feed",
      type: "activity",
      app: true,
      web: true,
    },
    // {
    //   name: "User profile",
    //   icon: "MdPerson",
    //   componentName: "profile",
    //   app: true,
    //   web: true,
    // },
    {
      name: "Partners",
      icon: "IoIosPeople",
      type: "partner",
      app: true,
      web: true,
    },
    {
      name: "Agenda",
      icon: "MdSchedule",
      type: "agenda",
      app: true,
      web: true,
    },
    {
      name: "Web View",
      icon: "MdWeb",
      type: 'webview',
      multiple: true,
      app: true,
      web: true,
    },
    {
      name: "Social Media",
      icon: "FiMessageSquare",
      type: 'social',
      app: true,
      web: true,
    }, {
      name: "Chat list",
      icon: "MdChatBubbleOutline",
      ict: "material",
      componentName: "chats",
      app: true,
      web: true,
    }, {
      name: "Venues",
      type: 'venue',
      icon: "MdPlace",
      app: true,
      web: true,
    }
    , {
      name: "Documents",
      type: 'document',
      icon: "FiFileText",
      app: true,
      web: true,

    }, {
      name: "Surveys",
      type: 'survey',
      icon: "MdRecordVoiceOver",
      app: true,
      web: true,

    }, {
      name: "Quizzes",
      type: 'quiz',
      icon: "FiMap",
      app: true,
      web: true,

    }, {
      name: "InfoBooth",
      type: 'infobooth',
      icon: "FaInfoCircle",
      app: true,
      web: true,

    }, {
      name: "Authors",
      type: 'author',
      icon: "MdPeople",
      app: true,
      web: true,

    }, {
      name: "Floormap",
      type: 'floormap',
      icon: "FaMapSigns",
      app: true,
      web: true,
    }, {
      name: "Organising Comittee",
      type: 'comittee',
      icon: "FiPlusCircle",
      app: true,
      web: true,
    }, {
      name: "Externalview",
      type: 'extview',
      icon: "FiPlusCircle",
      app: true,
      web: true,
    }, {
      name: "Welcome",
      type: 'welcome',
      icon: "FiPlusCircle",
      app: true,
      web: true,
    }
  ]
}

export default sections;


// WEBPACK FOOTER //
// ./src/config/builder/sections_config.js